import { Injectable } from '@angular/core';
import { SuperHttpClientProvider } from '@app/core/http';
import { Observable } from 'rxjs';

export interface PestMagnitudeConfigPayload {
  temperatureSource: string | null;
  humiditySource: string | null;
  precipitationSource: string | null;
  windSource: string | null;
  temperatureSensorId: number | null;
  humiditySensorId: number | null;
  precipitationSensorId: number | null;
  windSensorId: number | null;
  temperatureAemetStationId: string | null;
  temperatureSiarStationId: string | null;
  humidityAemetStationId: string | null;
  humiditySiarStationId: string | null;
  precipitationAemetStationId: string | null;
  precipitationSiarStationId: string | null;
  windAemetStationId: string | null;
  windSiarStationId: string | null;
}

@Injectable({
  providedIn: 'root'
})
export class PestMagnitudeConfigService {
  constructor(private $http: SuperHttpClientProvider) {}

  getConfig<T = any>(idModule: number): Observable<T> {
    return this.$http.default.get(
      `/admin/module/${idModule}/pest-magnitude-config`
    );
  }

  saveConfig(
    idModule: number,
    payload: PestMagnitudeConfigPayload
  ): Observable<any> {
    return this.$http.default.put(
      `/admin/module/${idModule}/pest-magnitude-config`,
      payload
    );
  }
}
